import React from 'react'
import {marked} from 'marked'
import styles from './Markdown.module.scss'

export const Markdown = ({source, ...props}) => {
  return <div className={styles.markdown} {...props} dangerouslySetInnerHTML={{__html: marked(source)}} />
}
